import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import {
  NavController,
  AlertController,
  ToastController,
  NavParams,
  ModalController,
  IonicModule,
} from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { AcompanhamentoAddPartPage } from "../acompanhamento-add-part/acompanhamento-add-part.page";
import { AcompanhamentoAddRespPage } from "../acompanhamento-add-resp/acompanhamento-add-resp.page";
import { AcompanhamentoAddPage } from "../acompanhamento-add/acompanhamento-add.page";
import { AcompanhamentoFinalizarPage } from "../acompanhamento-finalizar/acompanhamento-finalizar.page";
import { AcompanhamentoPartDetPage } from "../acompanhamento-part-det/acompanhamento-part-det.page";
import { AcompanhamentoReagendarPage } from "../acompanhamento-reagendar/acompanhamento-reagendar.page";
import { AcompanhamentoProvider } from "src/app/services/acompanhamento/acompanhamento";
import { format, isBefore, parseISO } from "date-fns";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { DateFormatPipe } from "src/app/pipes/date-format/date-format";
import { ImagePipe } from "src/app/pipes/image/image";
import { UserProvider } from "src/app/services/user/user";

@Component({
  selector: "app-acompanhamento-gerenciar",
  templateUrl: "./acompanhamento-gerenciar.page.html",
  styleUrls: ["./acompanhamento-gerenciar.page.scss"],
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, DateFormatPipe, TranslateModule, ImagePipe],
})
export class AcompanhamentoGerenciarPage implements OnInit {
  @ViewChild("descricao") descricaoEl!: ElementRef<HTMLParagraphElement>;
  acompanhamento: any = {};
  isResponsavel: any = 0;
  showDescricao: any = 0;
  dateToCompare: any = format(new Date(), "yyyy-MM-dd");
  historico = false;
  disabledAcompanhamento: any;
  disabledCompromisso: any;
  mostrarTexto = false;
  isOverflowing = false;
  maxChars = 40;
  constructor(
    public navCtrl: NavController,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
    private translate: TranslateService,
    public acompanhamentoProvider: AcompanhamentoProvider,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public userProvider: UserProvider
  ) {
    this.acompanhamento = this.navParams.get("acompanhamento");
    this.isResponsavel = this.navParams.get("isResponsavel");
    this.historico = this.navParams.get("historico");
    this.showDescricao = this.navParams.get("showDescricao");
    this.disabledAcompanhamento = this.userProvider.hasConfig(214);
    this.disabledCompromisso = this.userProvider.hasConfig(213);
  }

  ngOnInit() {}

  ngAfterViewInit() {
    this.isOverflowing = this.acompanhamento.descricao.length > this.maxChars;
  }

  getFontColor(acompanhamento: { cor: any }) {
    return acompanhamento.cor;
  }

  getIcon(acompanhamento: { icone: string | string[] }) {
    if (acompanhamento.icone.includes(" fa-")) {
      return acompanhamento.icone;
    } else {
      return "fas fa-" + acompanhamento.icone;
    }
  }

  async editAcompanhamento(acompanhamento: any) {
    const modalPage = await this.modalCtrl.create({
      component: AcompanhamentoAddPage,
      componentProps: { acompanhamento: acompanhamento, tipo: this.navParams.get("tipo") },
    });
    modalPage.present();

    const { data } = await modalPage.onWillDismiss();
    if (data) {
      this.acompanhamento.acao = data.acao;
      this.acompanhamento.categoria = data.categoria;
      this.acompanhamento.status = data.status;
      this.acompanhamento.datahora = data.datahora;
      this.acompanhamento.dataHoraFim = data.dataHoraFim;
      this.acompanhamento.descricao = data.descricao;
      this.acompanhamento.restrito = data.restrito;
      this.acompanhamento.titulo = data.titulo;
    }
  }

  async editParticipantes(participantes: any) {
    const modalPage = await this.modalCtrl.create({
      component: AcompanhamentoAddPartPage,
      componentProps: { acompanhamento: this.acompanhamento, participantes: participantes },
    });
    modalPage.present();

    const { data } = await modalPage.onWillDismiss();
    if (data) {
      this.acompanhamento.participantes = data;
    }
  }

  async editResponsavel(responsaveis: any) {
    const modalPage = await this.modalCtrl.create({
      component: AcompanhamentoAddRespPage,
      componentProps: { acompanhamento: this.acompanhamento, responsaveis: JSON.parse(JSON.stringify(responsaveis)) },
    });
    modalPage.present();
    const { data } = await modalPage.onWillDismiss();
    if (data) {
      this.acompanhamento.responsaveis = data;
    }
  }

  isAtrasado(data: string) {
    let date = format(parseISO(data), "yyyy-MM-dd");
    const result = isBefore(new Date(date), new Date(this.dateToCompare));
    return result;
  }

  async finalizar(acompanhamento: any) {
    const modalPage = await this.modalCtrl.create({
      component: AcompanhamentoFinalizarPage,
      componentProps: { acompanhamento: acompanhamento },
    });
    await modalPage.present();

    const { data } = await modalPage.onDidDismiss();

    if (data) {
      this.acompanhamento.status = data.status;
      this.acompanhamento.tipo = data.tipo;
      this.modalCtrl.dismiss(data);
    }
  }

  async assumir(acompanhamento: { id: any }) {
    let alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: this.translate.instant("Atenção"),
      message: this.translate.instant("Deseja realmente assumir a responsabilidade desse acompanhamento?"),
      buttons: [
        {
          text: this.translate.instant("Não"),
          handler: () => {},
        },
        {
          text: this.translate.instant("Sim"),
          handler: () => {
            this.acompanhamentoProvider.assumir(acompanhamento.id).subscribe(async (data) => {
              this.acompanhamento.responsaveis.push(data);
              this.isResponsavel = true;

              const toast = await this.toastCtrl.create({
                message: this.translate.instant("Acompanhamento assumido com sucesso!"),
                duration: 3000,
              });

              toast.present();
            });
          },
        },
      ],
    });
    alert.present();
  }

  async reagendar(acompanhamento: any) {
    const modalPage = await this.modalCtrl.create({
      component: AcompanhamentoReagendarPage,
      componentProps: { acompanhamento: acompanhamento },
    });
    modalPage.present();

    const { data } = await modalPage.onDidDismiss();
    if (data) {
      this.modalCtrl.dismiss((this.acompanhamento.tipo = data.tipo));
    }
  }

  async abrirDetalhes(participante: any) {
    const modalPage = await this.modalCtrl.create({
      component: AcompanhamentoPartDetPage,
      componentProps: { pessoa: participante },
    });
    modalPage.present();
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  async encaminhar(acompanhamento: any) {
    const modalPage = await this.modalCtrl.create({
      component: AcompanhamentoAddPage,
      componentProps: { acompanhamento: acompanhamento, isAcompanhamento: true, tipo: this.navParams.get("tipo") },
    });
    modalPage.present();
  }

  lerMais() {
    this.mostrarTexto = !this.mostrarTexto;
  }
}
